<div
  class="airport-slider-container airport-slider-desktop"
  *ngIf="isVisible"
  [style.--slider-items-count]="sliderItemsCount">

  <div
    class="airport-slider-route-list"
    cdkDropList
    cdkDropListOrientation="horizontal"
    [cdkDropListData]="routeAirports"
    (cdkDropListDropped)="dropRouteAirport($event)"
  >
    <div
      class="airport-slider-item draggable"
      *ngFor="let el of routeAirports"
      cdkDrag
      (click)="setActiveAirport(el)"
    >
      <app-airports-slider-el
        [el]="el"
        [isActive]="el.active"
        [hasError]="hasAirportError(el)"
        [canDelete]="el.active && selectedAirports.length > 1 && isAirportPage"
        (deleteAirport)="removeCurrentAirport($event)"
      />
    </div>
  </div>

  <div
    class="airport-slider-add"
    *ngIf="canAddMoreAirports && isAirportPage"
    (click)="goToAddAirport()"
  >
    <div class="airport-slider-add-icon">+</div>

    <div class="airport-slider-add-texts">
      <div class="airport-slider-add-title">
        {{ languageService.translate(['Add airport', 'Добавить аэропорт']) }}
      </div>

      <div class="airport-slider-add-subtitle">
        {{ languageService.translate(['Search by city or airport', 'Поиск по городу/аэропорту']) }}
      </div>
    </div>
  </div>

</div>

<div
  class="airport-slider-mobile"
  *ngIf="isVisible"
  [style.--slider-items-count]="sliderItemsCount"
>
  <div
    class="airport-mobile-card"
    *ngFor="let el of routeAirportsMobile; let i = index"
    [class.active]="el.active"
    [class.error]="hasAirportError(el)"
    [class.has-actions]="el.active && isAirportPage"
  >
    <button
      class="airport-mobile-select"
      type="button"
      (click)="setActiveAirport(el)"
    >
      <div class="airport-mobile-flag">
        <img
          *ngIf="airportService.getCountryCode(el)"
          [src]="airportService.getAirportFlagUrl(el)"
          [alt]="getAirportFlagAlt(el)"
        />
      </div>

      <div class="airport-mobile-texts">
        <div class="airport-mobile-top">
        <span class="airport-mobile-code">
          {{ getAirportCode(el) }}
        </span>

          <span
            class="airport-mobile-role-icon"
            *ngIf="el.routeRole"
            [style.--role-icon]="'url(' + getAirportRoleIconUrl(el) + ')'">
        </span>
        </div>

        <div class="airport-mobile-city">
          {{ getAirportCity(el) }}
        </div>
      </div>
    </button>

    <div
      class="airport-mobile-actions"
      *ngIf="el.active && isAirportPage"
    >
      <button
        class="airport-mobile-move"
        type="button"
        [disabled]="i === 0"
        [attr.aria-label]="languageService.translate([
      'Move airport earlier',
      'Переместить аэропорт раньше'
    ])"
        (click)="moveRouteAirport(i, -1)"
      >
        ‹
      </button>

      <button
        class="airport-mobile-move"
        type="button"
        [disabled]="i === routeAirportsMobile.length - 1"
        [attr.aria-label]="languageService.translate([
      'Move airport later',
      'Переместить аэропорт дальше'
    ])"
        (click)="moveRouteAirport(i, 1)"
      >
        ›
      </button>

      <button
        class="airport-mobile-delete"
        type="button"
        *ngIf="selectedAirports.length > 1"
        [attr.aria-label]="languageService.translate([
      'Remove airport',
      'Удалить аэропорт'
    ])"
        (click)="removeCurrentAirport($event)"
      >
        +
      </button>
    </div>
  </div>

  <button
    class="airport-mobile-add-btn"
    type="button"
    *ngIf="canAddMoreAirports && isAirportPage"
    (click)="goToAddAirport()"
  >
    +
  </button>

</div>
